// extracted by mini-css-extract-plugin
module.exports = {"tagContainer":"styles_tagContainer__3eKC1","badge":"styles_badge__1pCz6","active":"styles_active__1m2OP","inactive":"styles_inactive__mkmmt"};